import React, { Component } from 'react';

import { Form, Input, Button, Modal, InputNumber } from 'antd';
const FormItem = Form.Item;

class CheckingSettingForm extends Component {

  state = {    
    modalVisible: false
  }

  form = null;

  constructor(props) {
    super(props);        
  } 

  componentDidMount() {
    this.props.defaultValues 
      ? this.props.form.setFieldsValue(this.props.defaultValues) 
      : null;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {        
        this.props.onSuccess ? this.props.onSuccess(this.props.form, values) : null;
        this.setState({modalVisible: false}); 
      }
    });
  }

  renderForm() {

    const { getFieldDecorator } = this.props.form;
    
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => {this.form = ref}}>
        <FormItem
          {...formItemLayout}
          label="Tolerance začátku parkovací doby [min]" >
          {getFieldDecorator('Tolerance1', {            
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={9999} />
          )}
        </FormItem> 
        <FormItem
          {...formItemLayout}
          label="Tolerance konce parkovací doby [min]" >
          {getFieldDecorator('Tolerance2', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={9999} />
          )}
        </FormItem>    
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {      
    if (this.props.type && this.props.type === 'modal') {
      return(
        <div>
          <Button onClick={() => { this.setState({modalVisible:true}); }}>Nastavení</Button>        
          <Modal
            title="Nastavení kontroly"
            visible={this.state.modalVisible}
            footer={<p></p>}>
            {this.renderForm()}
          </Modal>
        </div>
      )
    } else {
      return this.renderForm();    
    }
  }
}

const WrappedParkinglocationForm = Form.create()(CheckingSettingForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/CheckingSettingForm.js